import { t } from "@lingui/macro";
import { useInvoiceDetailStore } from "../../../store";
import { Item } from "../../common";

export const BillingEntity = () => {
  const store = useInvoiceDetailStore();

  return (
    <div>
      <Item onlyLabel label={store.invoice?.billingEntity.legal_name} />
      <Item
        label={t`Address`}
      >{`${store.invoice?.billingEntity?.street}, ${store.invoice?.billingEntity?.city}, ${store.invoice?.billingEntity?.zip} ${store.invoice?.billingEntity?.country.name}`}</Item>
      <Item label={t`Invoice e-mail address`}>
        {store.invoice?.billingEntity.invoice_email}
      </Item>
      <Item label={t`Reg. no`}>
        {store.invoice?.billingEntity.registration_no}
      </Item>
      <Item label={t`Tax ID`}>{store.invoice?.billingEntity.tax_no}</Item>
      <Item label={t`VAT no.`}>{store.invoice?.billingEntity.vat_no}</Item>
    </div>
  );
};
